module.exports = __webpack_public_path__ + "media/flags/flag-gt-4fd6d833.svg";